export default "__VITE_PUBLIC_ASSET__8d481ceb__"